import { createContext, useContext, useEffect, useState } from "react"
import PropTypes from 'prop-types'
import { ethers } from 'ethers';
import { getWalletTokens } from "../../web3/tmp";

const web3Context = createContext()


function Web3Provider({ children }) {
    const [connectedState, setConnectedState] = useState({
        isConnected: false,
        error: ''
    })
    const [account, setAccount] = useState()
    const [walletBalance, setWalletBalance] = useState()


    const getBalance = async () => {
        const [account] = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const balance = await provider.getBalance(account);
        setWalletBalance(ethers.utils.formatEther(balance));
    };


    const checkIsConnected = async () => {
        if (window?.ethereum?.isMetaMask) {

            try {
                const accounts = await window.ethereum.request({
                    method: "eth_requestAccounts",
                })
                setAccount(accounts[0])
                setConnectedState(prev => ({
                    error: '',
                    isConnected: true
                }))
            } catch (error) {
                if (error.code === -32002) {
                    setConnectedState(prev => ({
                        error: 'Click on MetaMask Icon And Log In',
                        isConnected: false
                    }))
                }
            }
        } else {
            setConnectedState(prev => ({
                error: 'Please install MetaMask to Continue!',
                isConnected: false
            }))
        }
    }

    const getWalletNft = async () => {
        const res = await getWalletTokens('0xee425bbbec5e9bf4a59a1c19efff522ad8b7a47a')
        console.log("🚀 ~ file: Web3Provider.js:55 ~ getWalletNft ~ res", res)
    }

    useEffect(() => {
        checkIsConnected()
    }, [])

    useEffect(() => {
        if (account) {
            getBalance()
            // getWalletNft()

        }
    }, [account])


    return (
        <web3Context.Provider
            value={{
                connectedState,
                account,
                walletBalance
            }}
        >
            {children}
        </web3Context.Provider>
    )
}
Web3Provider.propTypes = {
    children: PropTypes.any,
}



function useWeb3() {
    const context = useContext(web3Context)
    if (context === undefined) {
        throw new Error('useWeb3 must be used within an AuthProvider')
    }
    return context
}

export { useWeb3 }
export default Web3Provider